export const translations = {
  'sv': {
    errorEmpty: 'Får inte vara tom',
    errorPostalCode: 'Kan inte hitta postkoden',
    required: 'obligatoriskt',
    addressNotFound: 'Adressen hittades inte'
  },
  'en': {
    errorEmpty: 'Cannot be empty',
    errorPostalCode: 'Could not find postalcode',
    required: 'required',
    addressNotFound: 'Address not found'
  },
  'da': {
    errorEmpty: 'Kan ikke være tom',
    errorPostalCode: 'Kunne ikke finde postnummeret',
    required: 'påkrævet',
    addressNotFound: 'Adressen blev ikke fundet'
  },
  'no': {
    errorEmpty: 'Cannot be empty',
    errorPostalCode: 'Could not find postalcode',
  },
  'fi': {
    errorEmpty: 'Cannot be empty',
    errorPostalCode: 'Could not find postalcode',
    required: 'pakollinen'
  },
  'de': {
    errorEmpty: 'Cannot be empty',
    errorPostalCode: 'Could not find postalcode',
  },
  'zh': {
    errorEmpty: 'Cannot be empty',
    errorPostalCode: 'Could not find postalcode',
  },
  'fr': {
    errorEmpty: 'Cannot be empty',
    errorPostalCode: 'Could not find postalcode',
  },
  'es': {
    errorEmpty: 'Cannot be empty',
    errorPostalCode: 'Could not find postalcode',
  },
  'nl': {
    errorEmpty: 'Cannot be empty',
    errorPostalCode: 'Could not find postalcode',
  },
  'it': {
    errorEmpty: 'Cannot be empty',
    errorPostalCode: 'Could not find postalcode',
  },
  'tr': {
    errorEmpty: 'Cannot be empty',
    errorPostalCode: 'Could not find postalcode',
  },
  'pl': {
    errorEmpty: 'Cannot be empty',
    errorPostalCode: 'Could not find postalcode',
  },
  'pt': {
    errorEmpty: 'Cannot be empty',
    errorPostalCode: 'Could not find postalcode',
  },
  'pt-BR': {
    errorEmpty: 'Cannot be empty',
    errorPostalCode: 'Could not find postalcode',
  },
};
